import { text } from './text.i18n';
import { validation } from './validation.i18n';
export const appLanguage = { text, validation };
